import { ref } from "vue";

let uuidSequence = 1;

export const useUUID = () => {
	return ref(uuidSequence++);
};
